import { render, staticRenderFns } from "./recyclePicture.vue?vue&type=template&id=0ab9b027&scoped=true&"
import script from "./recyclePicture.vue?vue&type=script&lang=js&"
export * from "./recyclePicture.vue?vue&type=script&lang=js&"
import style0 from "./recyclePicture.vue?vue&type=style&index=0&id=0ab9b027&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab9b027",
  null
  
)

export default component.exports